import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * HARDENING V1 (LOT 4) — RÉDUIT À SA SEULE RESPONSABILITÉ : <html lang>.
 *
 * AVANT : ce composant (LOT 500/529) émettait title/description/canonical
 * depuis SEO_META (i18n/routes.js) en CONCURRENCE avec PublicSeoDefaults et
 * les <SEOHead> de pages. Sa liste SELF_MANAGED_SEO_PAGES avait dérivé :
 * /fr/demander-acces, /fr/mentions-legales (entre autres) exposaient DEUX
 * canonicals différents — dont un construit sur window.location.origin
 * (http://127.0.0.1:8099/… dans les snapshots prerender servis aux moteurs).
 *
 * APRÈS : la SSOT des métadonnées publiques est PublicSeoDefaults (défauts
 * du layout) + <SEOHead> de page (prioritaire via SeoOwnership). LanguageMeta
 * ne pose plus que l'attribut de langue du document, qu'aucun autre
 * composant ne gère.
 */
export default function LanguageMeta() {
  const { pathname } = useLocation();
  const seg = pathname.split('/')[1];
  const lang = seg === 'en' ? 'en' : 'fr';
  return (
    <Helmet>
      <html lang={lang} />
    </Helmet>
  );
}
